<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import { getDay, parseDateFromString } from "../../utils";
  import LunchItem from "./LunchItem.svelte";
  import type { StoresKey } from "~/stores";
  import LunchFilter from "./LunchFilter.svelte";
  import { sortByStoreName } from "./utils";
  import { getDaysOfTheWeek } from "~/util/date-n-time";

  export let request_store_key: StoresKey;
  const { locale, lunch, stores, T } = getStoresContext(request_store_key);

  $: sorted_lunch = sortByStoreName([...$lunch]);
  $: weekdays = getDaysOfTheWeek($locale);

  // Use the current day of the week
  $: activeDay = new Date().getDay();
  
  function changeActiveDay(event: CustomEvent): string {
    return (activeDay = event.detail);
  }

  $: t = $T;
  
  // Filter lunch items to only include those that have a menu for the active day
  $: filtered_lunch = sorted_lunch.filter(item => 
    item.dailyLunchMenus.some(menu => getDay(menu.day) === activeDay)
  );
</script>

{#if $lunch.length && $stores.length}
  <div class="row">
    <div class="col-12">
      <LunchFilter
        on:changeActiveDay={changeActiveDay}
        {request_store_key} {weekdays} />
    </div>
  </div>
  <div class="mb-lg-7 mb-5" />
  {#each filtered_lunch as item}
    <LunchItem {item} {request_store_key} {activeDay} />
  {/each}
{:else}
  <div class="row">
    <div class="col-12">
      <h2 class="col-12 text-center mb-sm-5 mb-4">{t`no content`}</h2>
    </div>
  </div>
{/if}

<style lang="scss">
  .select-mobile {
    background-color: #000;
    color: #fff;
    display: block;
    width: 100%;
  }

  .icon-in-input {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
  }

  select {
    background: none !important;
    background-image: none !important;
    background-color: #000;
    color: #fff;
    padding: 14px 16px;
    appearance: none;
    width: 100%;
  }

  .day {
    border-bottom: 1px solid #000000;
    cursor: pointer;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    padding: 0.6rem 0;
  }
  .day.active {
    background-color: #000000;
    color: #ffffff;
  }
  .day:hover {
    background-color: #000000;
    color: #ffffff;
  }
</style>
